// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__3xt1-","header":"styles_header__1tnlS","headerBlock":"styles_headerBlock__1mzDE","title":"styles_title__3P690","id":"styles_id__1d_lp"};